import { getEnvUrl, getToken } from "../../utils/Api";
import axios from 'axios';

export const randers3data = async (key) => {

  try {
    const response = await axios.get(`${getEnvUrl()}/admin/settings/getSettings?module=${key}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const responseData = response.data.data;
    if (response.data.status) {
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

export async function updatesettings(obj, inputdata) {
  try {
    const response = await axios.put(`${getEnvUrl()}/admin/settings/S3settings`, inputdata, {
      headers: {
        'User-Agent': 'My User Agent',
        Authorization: `Bearer ${getToken()}`,
      },
    });

    if (response.status === 200) {
      alert(response.data.message);
      obj.prop('disabled', false);
    } else {
      throw new Error('Failed to update data');
    }
  } catch (error) {
    console.error('Error updating data:', error);
    obj.prop('disabled', false);
  }
}
